import React from "react";
import { motion } from "framer-motion";
import { FolderLock } from "lucide-react";

const Projects = ({ projects }) => {
  if (!projects?.length) return null;

  return (
    <section id="casefiles" className="py-24 md:py-32 border-t border-white/10" data-testid="casefiles-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-4 flex items-center gap-2">
          <FolderLock className="h-4 w-4" /> THE CASE FILES — DECLASSIFIED
        </p>
        <h2 className="font-display text-3xl md:text-4xl text-gray-100 mb-16">
          Six missions, <span className="italic text-emerald-400">zero incidents.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {projects.map((p, i) => (
            <motion.article
              key={p.id}
              className="group bg-[#0a0a0a] hover:bg-[#0d0d0d] transition-colors flex flex-col"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: (i % 3) * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
              data-testid={`casefile-card-${p.id}`}
            >
              <div className="relative overflow-hidden h-44">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors" />
                <span className="absolute top-3 left-3 font-mono text-[10px] tracking-widest text-emerald-400 bg-black/80 border border-emerald-500/30 px-2 py-1">
                  FILE {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display text-xl text-gray-100 mb-3 group-hover:text-emerald-400 transition-colors">{p.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-6 flex-1">{p.description}</p>
                <div className="flex flex-wrap gap-2">
                  {p.tags.map((tag) => (
                    <span key={tag} className="font-mono text-[10px] tracking-wider uppercase text-gray-400 border border-white/10 px-2 py-1">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
